import { log } from 'log';
import { addParamsToUrl } from 'js/utils/url.util';

export const areSourcesEqual = (src1: string | string[], src2: string | string[]) => {
    if (typeof src1 === 'string' && typeof src2 === 'string') {
        return src1 === src2;
    }

    const sources1 = Array.isArray(src1) ? src1 : [src1];
    const sources2 = Array.isArray(src2) ? src2 : [src2];

    if (sources1.length !== sources2.length) {
        return false;
    }

    return sources1.every((s1, i) => s1 === sources2[i]);
};

/**
 * It is really important to add query string parameters here
 * because in hub2-shared environment we must pass parameters to all local assets
 * @param src {String}
 * @return {String}
 */
export const addAllowedParamsToSrc = (src: string): string => {
    try {
        const search = new URLSearchParams(location.search);
        const casinoname = search.get('casinoname');
        const site = search.get('site');
        const allowedParams = {
            ...casinoname && { casinoname },
            ...site && { site }
        };

        return addParamsToUrl(allowedParams, src);
    } catch (error: any) {
        log('error', error?.message);

        return '';
    }
};
